import { z } from 'zod';
import { baseModelSchema } from '../../../model/baseModel';
import { IUnitOfMeasureFormValues } from './unitOfMeasureFormValues';

/**
 * Zod schema for validating unit of measure data.
 * Extends the base model schema with unit of measure-specific fields.
 *
 * @property {string} code - Unique identifier code (max 5 characters)
 * @property {string} name - Name of the unit of measure (max 255 characters)
 * @property {number} typeId - ID of the unit of measure type
 */
export const unitOfMeasureSchema = baseModelSchema.extend({
    code: z.string().nonempty('Code is required').max(5, 'Code can only be up to 5 characters long.'),
    name: z.string().nonempty('Name is required').max(255, 'Name can only be up to 255 characters long.'),
    typeId: z.number(),
});

/**
 * TypeScript interface representing a Unit of Measure object.
 * Generated from the Zod schema for type safety.
 */
export type IUnitOfMeasure = z.infer<typeof unitOfMeasureSchema>;

// Convert form values into a valid unitOfMeasure object
export function UnitOfMeasure(formValues : IUnitOfMeasureFormValues) : IUnitOfMeasure {
    const { unitOfMeasureType, ...rest } = formValues;

    return unitOfMeasureSchema.parse({
        ...rest,
        typeId: unitOfMeasureType?.value ? Number(unitOfMeasureType.value) : undefined,
    });
};
